<template>
  <div v-click-outside="outsideHandleClick">
    <el-popover placement="bottom" width="300" v-model:visible="visible" :teleported="false" trigger="contextmenu"
      :trigger-keys="[]">
      <div class="search-content" :v-loading="isLoading">
        <!-- 组织架构树-对应人员 -->
        <tq-version-choose-box v-for="(item, index) in dataList" :key="index" :item="item"
          @change="onChange($event, item)" :multiple="multiple">
          <!-- 列表中的展示名称 -->
          <template #itemName>
            <span>{{ item.code }}-{{ item.name }}</span>
          </template>
          <!-- 展示名称的 tooltip -->
          <template #tooltipContent>
            <span>{{ item.code }}-{{ item.name }}</span>
          </template>
        </tq-version-choose-box>
        <div class="empty absolute flex items-center justify-center" v-if="dataList.length === 0">
          <div>
            <img :src="EmptyImg">
            <p>暂无数据</p>
          </div>
        </div>
      </div>
      <template #reference>
        <el-input size="small" v-model="inputValue" :placeholder="placeholder" clearable class="tq-version-search-input"
          prefix-icon="el-icon-search" @focus="() => { visible = true; isFocus = true; }" @blur="isFocus = false"
          @input="onInput" style="width: 300px" />
      </template>
    </el-popover>
  </div>
</template>

<script lang="ts">
import { ref, watch, onMounted } from 'vue'
import tqVersionChooseBox from '../../tqVersionChooseBox'
import { ClickOutside as vClickOutside } from 'element-plus'
import * as _ from 'lodash'
import EmptyImg from "../../../images/img_empty.png"

export default {
  name: "TqVersionSearchInput",
  emits: ['change'],
  components: {
    tqVersionChooseBox
  },
  props: {
    placeholder: {
      type: String,
      default: "搜索部门编码或名称"
    },
    queryPath: {
      type: String,
      default: "",
      required: true
    },
    maxItemSize: {
      type: Number,
      default: 20
    },
    queryField: {
      type: String,
      default: "keyword"
    },
    extraParams: {
      type: Object,
      default() {
        return {}
      }
    },
    multiple: {
      type: Boolean,
      default: true
    },
    selectedList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 0-选人 1-选部门
    type: {
      type: Number,
      default: 0
    },
    // 组织机构树完整数据
    orgVersionTreeData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup(props, { emit }) {
    const inputValue = ref("")
    const visible = ref(false)
    const dataList = ref<any[]>([])
    const isFocus = ref(false)
    const isLoading = ref(false)
    const handleInput = () => {
      visible.value = true
      isLoading.value = true
      onInput()
    }
    const onInput = _.debounce(function () {
      if (inputValue.value) {
        getSearchList(inputValue.value)
      } else {
        isLoading.value = false
      }
    }, 500)

    const findNodesWithKeyword = (tree:any[], keyword?:string, result = []) => {
      for (const node of tree) {
        if (node.deptName.includes(keyword) || node.deptCode.includes(keyword)) {
          result.push((node as never))
        }

        if (node.deptList && node.deptList.length > 0) {
          findNodesWithKeyword(node.deptList, keyword, result)
        }
      }
      return result
    }
    const resetDataList = () => {
      dataList.value = []
    }

    const getSearchList = (query?: string) => {
      const list:any[] = []
      const treeData = props.orgVersionTreeData
      const matchingNodes = findNodesWithKeyword(treeData, query)
      matchingNodes.forEach((item:any) => {
        let isDept = props.type === 0
        let isDeptCheck = props.selectedList.some((childItem:any) => childItem.code === item.deptCode)
        let isPersonCheck = props.selectedList.some((childItem:any) => childItem.code === item.personCode)

        list.push({
          ...item,
          checked: isDept ? isPersonCheck : isDeptCheck,
          name: isDept ? item.personName : item.deptName,
          code: isDept ? item.personCode : item.deptCode,
          desc: isDept ? item.postName : typeSwitch(item.departLevel)
        })
      })
      dataList.value = list.slice(0, 100)
      isLoading.value = false
    }

    watch(() => props.selectedList, newValue => {
      if (newValue.length !== 0) {
        dataList.value.forEach(item => {
          item.checked =
            props.type === 0
              ? newValue.some((childItem:any) => childItem.code === item.personCode)
              : newValue.some((childItem:any) => childItem.code === item.deptCode)
        })
      } else {
        dataList.value.forEach(item => {
          item.checked = false
        })
      }
    }, { deep: true })

    const outsideHandleClick = () => {
      if (isFocus.value) return
      visible.value = false
    }

    const onChange = (e:any, value:any) => {
      if (props.multiple) {
        if (e) {
          props.selectedList.forEach((item:any) => {
            if (item.code === value.code) {
              item.checked = true
            }
          })
        }
      } else {
        dataList.value.forEach(item => {
          item.checked = item.code === value.code
        })
      }
      emit("change", e, value)
    }

    const typeSwitch = (value:any) => {
      switch (value) {
        case "01":
          return "集团组织"
        case "02":
          return "公司组织"
        case "03":
          return "一级部门"
        case "04":
          return "二级部门"
        case "05":
          return "三级部门"
        case "06":
          return "四级部门"
        case "07":
          return "五级部门"
        case "08":
          return "六级部门"
        case "09":
          return "七级部门"
      }
    }

    // 示例：在组件挂载时调用 getSearchList
    onMounted(() => {
      getSearchList()
    })

    return {
      EmptyImg,
      inputValue,
      visible,
      dataList,
      isFocus,
      isLoading,
      findNodesWithKeyword,
      getSearchList,
      outsideHandleClick,
      onChange,
      typeSwitch,
      onInput,
      handleInput,
      resetDataList,
      vClickOutside
    }
  }
}
</script>
